import React, { useState } from "react";
import Icon from "./Icon";

// Hides a post or letter behind its content warning until the reader chooses
// to see it. With no warning, the content shows as usual.
export default function ContentWarning({
  cw,
  children,
}: {
  cw?: string;
  children: React.ReactNode;
}) {
  const [shown, setShown] = useState(false);
  if (!cw || shown) return <>{children}</>;
  return (
    <div className="notice flex flex-col items-start gap-2">
      <p className="font-bold">
        <Icon name="warning" size={16} /> Content warning: {cw}
      </p>
      <p className="text-sm">The writer added this so you can choose when to read it.</p>
      <button type="button" className="btn btn-sm" onClick={() => setShown(true)}>
        Show it
      </button>
    </div>
  );
}
